import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { ChartsModule } from '../charts/charts.module';
import { SharedModule } from '@cpd-app/shared-module/shared.module';

import { SimilarMilitaryOccupationsComponent } from './containers/similar-military-occupations/similar-military-occupations.component';
import { MilitaryOccupationCardComponent } from './components/military-occupation-card/military-occupation-card.component';
import { MilitaryOccupationsComponent } from './containers/military-occupations/military-occupations.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    ChartsModule,
    ScrollingModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [
    MilitaryOccupationCardComponent,
    SimilarMilitaryOccupationsComponent,
    MilitaryOccupationsComponent
  ],
  exports: [SimilarMilitaryOccupationsComponent, MilitaryOccupationsComponent]
})
export class SimilarMilitaryOccupationsModule {}
